import {
  CONTACTS_REQUEST,
  CONTACTS_SUCCESS,
  CONTACTS_FAILURE,
  CONTACTS_RESET,
  CONTACTS_POST_REQUEST,
  CONTACTS_POST_SUCCESS,
  CONTACTS_POST_FAILURE,
  CONTACTS_POST_RESET,
  CONTACTS_DELETE_REQUEST,
  CONTACTS_DELETE_SUCCESS,
  CONTACTS_DELETE_FAILURE,
  CONTACTS_DELETE_RESET,
  CONTACTS_SEARCH_REQUEST,
  CONTACTS_SEARCH_SUCCESS,
  CONTACTS_SEARCH_FAILURE,
  CONTACTS_SEARCH_RESET,
} from '../actions/contacts';

interface ContactsListState {
  state: 'idle' | 'loading' | 'success' | 'failure';
  list: any[];
  more: boolean;
  error: any | null;
}

const initialState: ContactsListState = {
  state: 'idle',
  list: [],
  more: false,
  error: null,
};

export default function contactsList(state = initialState, action: any): ContactsListState {
  switch (action.type) {
    case CONTACTS_REQUEST:
      return {
        ...state,
        state: 'loading',
        error: null,
      };
    case CONTACTS_SUCCESS:
      return {
        ...state,
        list: action.payload.list || [], 
        more: action.payload.more ?? false, 
        state: 'success',
      };
    case CONTACTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        state: 'failure',
      };
    case CONTACTS_DELETE_SUCCESS:
      return {
        ...state,
        list: state.list
          .map((group: any) => ({
            ...group,
            accounts: group.accounts.filter((a: any) => a.id !== action.payload),
          }))
          .filter((group: any) => group.accounts.length > 0),
      };
    case CONTACTS_RESET:
      return initialState;
    default:
      return state;
  }
}




interface ContactsPostState {
  state: 'idle' | 'loading' | 'success' | 'failure';
  result?: any | null;
  error: any | null;
}

const initialStatePost: ContactsPostState = {
  state: 'idle',
  result: null,
  error: null,
};

export function contactsPost(state = initialStatePost, action: any): ContactsPostState {
  switch (action.type) {
    case CONTACTS_POST_REQUEST:
      return {
        ...state,
        state: 'loading',
        error: null,
        result: null,
      };
    case CONTACTS_POST_SUCCESS:
      return {
        ...state,
        result: action.payload, 
        state: 'success',
      };
    case CONTACTS_POST_FAILURE:
      return {
        ...state,
        error: action.payload, 
        state: 'failure',
      };
    case CONTACTS_POST_RESET:
      return initialStatePost;
    default:
      return state;
  }
}

interface ContactsSearchState {
  state: 'idle' | 'loading' | 'success' | 'failure';
  list: any[];
  error: any | null;
}

const initialStateSearch: ContactsSearchState = {
  state: 'idle',
  list: [],
  error: null,
};

export function contactsSearch(state = initialStateSearch, action: any): ContactsSearchState {
  switch (action.type) {
    case CONTACTS_SEARCH_REQUEST:
      return { ...state, state: 'loading', error: null };
    case CONTACTS_SEARCH_SUCCESS:
      return { ...state, state: 'success', list: action.payload.list || [] };
    case CONTACTS_SEARCH_FAILURE:
      return { ...state, state: 'failure', error: action.payload };
    case CONTACTS_SEARCH_RESET:
      return initialStateSearch;
    default:
      return state;
  }
}

interface ContactsDeleteState {
  state: 'idle' | 'loading' | 'success' | 'failure';
  error: any | null;
}

const initialStateDelete: ContactsDeleteState = {
  state: 'idle',
  error: null,
};

export function contactsDelete(state = initialStateDelete, action: any): ContactsDeleteState {
  switch (action.type) {
    case CONTACTS_DELETE_REQUEST:
      return { ...state, state: 'loading', error: null };
    case CONTACTS_DELETE_SUCCESS:
      return { ...state, state: 'success' };
    case CONTACTS_DELETE_FAILURE:
      return { ...state, state: 'failure', error: action.payload };
    case CONTACTS_DELETE_RESET:
      return initialStateDelete;
    default:
      return state;
  }
}